import { useLang } from '../../contexts/LangContext'

const labels = {
  pending: { el: 'Σε αναμονή', en: 'Pending' },
  confirmed: { el: 'Επιβεβαιωμένη', en: 'Confirmed' },
  in_progress: { el: 'Σε εξέλιξη', en: 'In progress' },
  completed: { el: 'Ολοκληρωμένη', en: 'Completed' },
  cancelled: { el: 'Ακυρωμένη', en: 'Cancelled' },
  declined: { el: 'Απορρίφθηκε', en: 'Declined' },
} as const

const classes: Record<string, string> = {
  pending: 'border-amber-200 bg-amber-50 text-amber-700',
  confirmed: 'border-sky-200 bg-sky-50 text-sky-700',
  in_progress: 'border-indigo-200 bg-indigo-50 text-indigo-700',
  completed: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  cancelled: 'border-rose-200 bg-rose-50 text-rose-700',
  declined: 'border-slate-200 bg-slate-100 text-slate-700',
}

export default function BookingStatusBadge({ status }: { status: string }) {
  const { locale } = useLang()
  const label = labels[status as keyof typeof labels]

  return (
    <span
      className={[
        'inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em]',
        classes[status] ?? 'border-slate-200 bg-slate-100 text-slate-700',
      ].join(' ')}
    >
      {label ? label[locale] : status}
    </span>
  )
}
